export default {
  SET_PAGINATION(state, data) {
    state.pagination = data;
  },
  SET_TENANT_PDF_TEMPLATE(state, tenantPdfTemplate) {
    state.tenantPdfTemplate = tenantPdfTemplate;
  },
  SET_TENANT_PDF_TEMPLATES(state, tenantPdfTemplates) {
    state.tenantPdfTemplates = tenantPdfTemplates;
  },
  ADD_TENANT_PDF_TEMPLATE(state, tenantPdfTemplate) {
    state.tenantPdfTemplates.push(tenantPdfTemplate);
  },
  UPDATE_TENANT_PDF_TEMPLATE(state, tenantPdfTemplate) {
    const certIndex = state.tenantPdfTemplates.findIndex(
      e => e.tenantPdfTemplateId === tenantPdfTemplate.tenantPdfTemplateId
    );
    Object.assign(state.tenantPdfTemplates[certIndex], tenantPdfTemplate);
  },
  DELETE_TENANT_PDF_TEMPLATE(state, itemId) {
    const certIndex = state.tenantPdfTemplates.findIndex(u => u.tenantPdfTemplateId === itemId);
    state.tenantPdfTemplates.splice(certIndex, 1);
  }
};
